<template>
  <div class="card-pos" v-show="isLoad">
    <div class="card">
      <div class="card-body h-100">
        <img class="card-img-top mt-3" :src="url" img-alt="Image" />
      </div>
      <div class="card-footer">
        <div class="card-text">{{ courier.title }}</div>
      </div>
      <small class="badge badge-info px-2 text-black custom-line">{{
        courier.name
      }}</small>
    </div>
  </div>
</template>
<script>
export default {
  name: "cardpos",
  props: ["courier", "disabled", "lockcourier"],
  data() {
    return {
      url: "img/brand/load-error.svg",
      isLoad: false,
    };
  },
  methods: {
    async getIcon() {
      this.isLoad = false;
      let icon = "image.svg";
      this.url = this.courier.icon
        ? this.courier.icon
        : "img/brand/load-error.svg";
      this.isLoad = true;
    },
  },
  beforeMount() {
    this.getIcon();
  },
};
</script>
<style>
.disabled {
  pointer-events: none;
  opacity: 0.5;
}
.lockcourier {
  pointer-events: none;
  opacity: 0.5;
}
.badge.badge-info.px-2.text-black.custom-line {
  white-space: normal;
}
</style>
